import { clientConnectorService } from "../services/clientConnector.service";
import { clientConnectorConstants } from "../constants/clientConnector.constants";

export const clientConnectorActions = {
  get,
  suggestions,
  clearSuggestions,
  create,
  update,
  testConnectorAuth,
  pushOnPremUpdate,
  remove,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    clientConnectorService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        if (error.response && error.response.status === 404) {
          dispatch(success(null));
        } else {
          dispatch(failure());
        }
      }
    );
  };

  function request(requestParameters) {
    return {
      type: clientConnectorConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: clientConnectorConstants.GET_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: clientConnectorConstants.GET_FAILURE };
  }
}

function suggestions(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    clientConnectorService.suggestions(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: clientConnectorConstants.GET_SUGGESTIONS_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: clientConnectorConstants.GET_SUGGESTIONS_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: clientConnectorConstants.GET_SUGGESTIONS_FAILURE };
  }
}

function clearSuggestions() {
  return (dispatch) => {
    dispatch(request());
  };

  function request() {
    return {
      type: clientConnectorConstants.CLEAR_SUGGESTIONS_REQUEST,
    };
  }
}

function create(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    clientConnectorService.create(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: clientConnectorConstants.CREATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: clientConnectorConstants.CREATE_SUCCESS };
  }
  function failure() {
    return {
      type: clientConnectorConstants.CREATE_FAILURE,
    };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    clientConnectorService.update(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: clientConnectorConstants.UPDATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: clientConnectorConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return {
      type: clientConnectorConstants.UPDATE_FAILURE,
    };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    clientConnectorService.remove(requestParameters).then(
      () => {
        dispatch(success());
      },
      (error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.title ||
          (typeof error.response?.data === "string" ? error.response.data : null) ||
          "Failed to delete connector.";
        dispatch(failure(errorMessage));
      }
    );
  };

  function request() {
    return { type: clientConnectorConstants.DELETE_REQUEST };
  }
  function success() {
    return { type: clientConnectorConstants.DELETE_SUCCESS };
  }
  function failure(message) {
    return { type: clientConnectorConstants.DELETE_FAILURE, payload: message };
  }
}

function testConnectorAuth(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    clientConnectorService.testConnectorAuth(requestBody).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return {
      type: clientConnectorConstants.TEST_AUTH_REQUEST,
      payload: requestBody,
    };
  }
  function success(response) {
    return {
      type: clientConnectorConstants.TEST_AUTH_SUCCESS,
      payload: response,
    };
  }
  function failure(error) {
    return {
      type: clientConnectorConstants.TEST_AUTH_FAILURE,
      payload: error.response.data.title,
    };
  }
}

function pushOnPremUpdate(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    clientConnectorService.pushOnPremUpdate(requestBody).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return {
      type: clientConnectorConstants.PUSH_ONPREM_UPDATE_REQUEST,
      payload: requestBody,
    };
  }
  function success(response) {
    return {
      type: clientConnectorConstants.PUSH_ONPREM_UPDATE_SUCCESS,
      payload: response,
    };
  }
  function failure(error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.title ||
      (typeof error.response?.data === "string" ? error.response.data : null) ||
      "Failed to push OnPrem update.";
    return {
      type: clientConnectorConstants.PUSH_ONPREM_UPDATE_FAILURE,
      payload: message,
    };
  }
}
